export const STEPS = [
  { key: "landlord", label: "Landlord" },
  { key: "property", label: "Property" },
  { key: "job", label: "Inspection job" },
  { key: "photos", label: "Photos" },
  { key: "checklist", label: "Checklist" },
  { key: "tenant", label: "Tenant" },
  { key: "report", label: "Report" },
];

export const CONDITIONS = ["Excellent", "Good", "Fair", "Poor", "Damaged", "Not Applicable"];
export const PHOTO_CATS = ["Exterior", "Entrance", "Rooms", "Appliances", "Meters", "Keys", "Safety devices", "Damages"];
export const INSPECTION_TYPES = ["Move-In", "Move-Out", "Mid-Term", "Video Walk-Around"];
export const STATUSES = ["Scheduled", "In Progress", "Completed"];
export const PROPERTY_TYPES = ["Apartment", "House", "Duplex", "Studio", "Townhouse"];
export const BER_RATINGS = ["", "A1", "A2", "A3", "B1", "B2", "B3", "C1", "C2", "C3", "D1", "D2", "E1", "E2", "F", "G"];
export const FURNISHED = ["Furnished", "Part-furnished", "Unfurnished"];
export const HEATING = ["Gas", "Oil", "Electric", "Heat Pump", "Solid Fuel"];
export const PARKING = ["None", "On-Street", "Driveway", "Garage"];
export const ID_VERIFIED = ["No", "Yes"];

export const CONDITION_STYLE = {
  Excellent: "bg-[#D1FAE5] text-[#065F46] border-[#34D399]",
  Good: "bg-[#DBEAFE] text-[#1E40AF] border-[#60A5FA]",
  Fair: "bg-[#FEF3C7] text-[#92400E] border-[#FBBF24]",
  Poor: "bg-[#DCFCE7] text-[#14532D] border-[#86EFAC]",
  Damaged: "bg-[#FEE2E2] text-[#991B1B] border-[#F87171]",
  "Not Applicable": "bg-[#F3F4F6] text-[#6B7280] border-[#E5E7EB]",
};

export const SIGNATURE_STATUS_PILL = {
  Pending: "bg-[#F1F5F9] text-[#475569] border-[#CBD5E1]",
  Sent: "bg-[#DBEAFE] text-[#1E40AF] border-[#60A5FA]",
  Signed: "bg-[#DCFCE7] text-[#14532D] border-[#86EFAC]",
  Declined: "bg-[#FEE2E2] text-[#991B1B] border-[#F87171]",
};

export const readAsDataURL = (file) =>
  new Promise((resolve, reject) => {
    const r = new FileReader();
    r.onload = () => resolve(r.result);
    r.onerror = reject;
    r.readAsDataURL(file);
  });

export const uid = () => Math.random().toString(36).slice(2, 10);
